import { useState } from "react";
import "../404/NotFound.css";

const NotFound = () => {
  const [theme, setTheme] = useState("dark");

  const toggleTheme = () => {
    const root = document.documentElement;

    if (theme === "dark") {
      root.style.setProperty("--bg-color", "#fff");
      root.style.setProperty("--text-color", "#000");
      setTheme("light");
    } else {
      root.style.setProperty("--bg-color", "#050505");
      root.style.setProperty("--text-color", "#fff");
      setTheme("dark");
    }
  };

  return (
    <main className="error-page">
      <div className="container-errorpage">
        <div className="eyes">
          <div className="eye">
            <div className="eye__pupil eye__pupil--left"></div>
          </div>
          <div className="eye">
            <div className="eye__pupil eye__pupil--right"></div>
          </div>
        </div>

        <div className="error-page__heading">
          <h1 className="error-page__heading-title">Looks like you're lost</h1>
          <p className="error-page__heading-desciption">404 error</p>
        </div>

        <a
          className="error-page__button"
          href="/"
          aria-label="back to home"
          title="back to home"
        >
          back to home
        </a>
      </div>

      <button className="color-switcher" onClick={toggleTheme}>
        {theme === "dark" ? "🌙" : "🌞"}
      </button>
    </main>
  );
};

export default NotFound;
